/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LevelInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class LevelApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Levels');
  }

  find(params?: Record<string, any>): Observable<LevelInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<LevelInterface[]>(path, httpParams);
  }
}
